import { createContext, useContext } from "react";
import type { InvoiceStore } from "./InvoiceStore";

export const InvoiceStoreContext = createContext({} as InvoiceStore);
export const useInvoiceStore = () => useContext(InvoiceStoreContext);
